import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const authApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "authApi",
  tagTypes: ["DevLogin", "DiscoverLogin"],
  endpoints: (builder) => ({
    loginUser: builder.mutation<API.Response.LoginResponse, API.Payload.LoginPayload>({
      query: (payload) => ({
        url: "/login",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["DevLogin"],
    }),
    masqueradeLogin: builder.mutation<API.Response.LoginResponse, API.Payload.MasqueradePayload>({
      query: (payload) => ({
        url: "/masquerade",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["DevLogin"],
    }),
    discoveryLogin: builder.mutation<API.Response.LoginResponse, API.Payload.DiscoveryLoginPayload>({
      query: (payload) => ({
        url: "/discovery-login",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["DiscoverLogin"],
    }),
  }),
})

export const { useLoginUserMutation, useMasqueradeLoginMutation, useDiscoveryLoginMutation } = authApi
